(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vehicle-finder-home"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vehicle-finder-home')) {
    customElements.define(
      'vehicle-finder-home',
      class VehicleFinderHome extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.plateInput = this.querySelector('[data-vehicle-plate]');
          this.lookupButton = this.querySelector('[data-vehicle-lookup]');
          this.status = this.querySelector('[data-vehicle-status]');

          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.lookupPlate();
          });
          this.plateInput.addEventListener('input', () => {
            this.plateInput.value = this.plateInput.value.toUpperCase();
          });
        }

        normalize(value) {
          return String(value || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '');
        }

        searchBrand(brand) {
          const aliases = {
            mercedesbenz: 'Mercedes',
            mercedes: 'Mercedes',
            volkswagen: 'Volkswagen',
            citroen: 'Citroën',
            man: 'MAN',
          };
          const normalized = this.normalize(brand);
          if (aliases[normalized]) return aliases[normalized];
          return String(brand || '')
            .toLowerCase()
            .replace(/(^|\s|-)[a-z]/g, (letter) => letter.toUpperCase());
        }

        vehicleModel(tradeName) {
          const normalizedTradeName = this.normalize(tradeName);
          const models = [
            ['Transit Custom', 'transitcustom'],
            ['Transit Connect', 'transitconnect'],
            ['Proace City', 'proacecity'],
            ['Crafter', 'crafter'],
            ['Transporter', 'transporter'],
            ['Caddy', 'caddy'],
            ['Sprinter', 'sprinter'],
            ['Vito', 'vito'],
            ['Citan', 'citan'],
            ['Master', 'master'],
            ['Trafic', 'trafic'],
            ['Kangoo', 'kangoo'],
            ['Movano', 'movano'],
            ['Vivaro', 'vivaro'],
            ['Combo', 'combo'],
            ['Boxer', 'boxer'],
            ['Expert', 'expert'],
            ['Partner', 'partner'],
            ['Jumper', 'jumper'],
            ['Jumpy', 'jumpy'],
            ['Berlingo', 'berlingo'],
            ['Ducato', 'ducato'],
            ['Scudo', 'scudo'],
            ['Doblo', 'doblo'],
            ['Transit', 'transit'],
            ['Daily', 'daily'],
            ['TGE', 'tge'],
            ['Proace', 'proace'],
            ['Dokker', 'dokker'],
            ['NV400', 'nv400'],
            ['NV300', 'nv300'],
            ['Interstar', 'interstar'],
            ['Primastar', 'primastar'],
          ];
          const match = models.find((model) => normalizedTradeName.includes(model[1]));
          if (match) return match[0];

          const ignored = /^(bluehdi|cdi|dci|hdi|multijet|tdi)$/i;
          const fallback = String(tradeName || '')
            .split(/\s+/)
            .find((part) => /[a-zÀ-ÿ]{3,}/i.test(part) && !ignored.test(part));
          if (!fallback) return '';
          return fallback.toLowerCase().replace(/(^|\s|-)[a-z]/g, (letter) => letter.toUpperCase());
        }

        modelSearchQuery(model) {
          const escapedModel = String(model).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
          return `(title:"${escapedModel}" OR tag:"${escapedModel}")`;
        }

        setStatus(message, state = '') {
          this.status.textContent = message;
          this.status.dataset.state = state;
        }

        async lookupPlate() {
          const plate = this.plateInput.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
          if (!/^[A-Z0-9]{6}$/.test(plate)) {
            this.setStatus(this.dataset.invalid, 'error');
            this.plateInput.focus();
            return;
          }

          this.lookupButton.setAttribute('aria-busy', 'true');
          this.lookupButton.disabled = true;
          this.setStatus('');

          try {
            const url = new URL(this.dataset.endpoint);
            url.searchParams.set('kenteken', plate);
            url.searchParams.set('$select', 'kenteken,merk,handelsbenaming,voertuigsoort');
            url.searchParams.set('$limit', '1');

            const response = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('RDW ' + response.status);

            const vehicles = await response.json();
            if (!vehicles.length) {
              this.setStatus(this.dataset.notFound, 'error');
              return;
            }

            const vehicle = vehicles[0];
            const brand = this.searchBrand(vehicle.merk);
            const model = this.vehicleModel(vehicle.handelsbenaming);

            if (!model) {
              this.setStatus(this.dataset.notFound, 'error');
              return;
            }

            this.setStatus(this.dataset.found + ' ' + [brand, model].filter(Boolean).join(' ') + '.');

            const params = new URLSearchParams();
            params.set('q', this.modelSearchQuery(model));
            params.set('vehicle_model', model);
            params.set('type', 'product');
            window.location.assign(this.dataset.searchUrl + '?' + params.toString());
          } catch (error) {
            this.setStatus(this.dataset.error, 'error');
          } finally {
            this.lookupButton.removeAttribute('aria-busy');
            this.lookupButton.disabled = false;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
